const ngLazy = [() => {
    return {
        link ( $scope ) {
           this.load();
        },
        load() {
            let picture = new Image();
            picture.onload = () => {
                this.test(picture.width > 0 && picture.height > 0);
            };
            picture.onerror = () => {
                this.test(false);
            };
            picture.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";

        },
        test (supportsWebP) {

            let images = Array.prototype.slice.call( document.querySelectorAll("[data-src]"));

            if ("IntersectionObserver" in window ) {
                let lazyImageObserver = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.intersectionRatio > 0 ) {
                            let lazyImage = entry.target;
                            let showWebP = supportsWebP && lazyImage.dataset.hasOwnProperty('webp') && lazyImage.dataset.webp === 'true';
                            let imageSrc = showWebP ? lazyImage.dataset.src.replace(/(jpg|jpeg|png)$/, 'webp') : lazyImage.dataset.src;
                            if ( imageSrc.length ) {
                                if ( lazyImage.tagName.toLowerCase() === 'svg' || lazyImage.tagName.toLowerCase() === 'div') {
                                    lazyImage.style.backgroundImage = "url('" + imageSrc + "')";
                                    lazyImage.style.backgroundSize = "cover";
                                }
                                if ( lazyImage.tagName.toLowerCase() === 'img') {
                                    lazyImage.src = imageSrc;
                                }
                                delete lazyImage.dataset.src;
                            }
                            lazyImageObserver.unobserve(lazyImage);
                        }
                    });
                });

                images.forEach(function(lazyImage) {
                    lazyImageObserver.observe(lazyImage);
                });

                return true;
            }
        }
    }
}];

export default ngLazy;
